import PropTypes from 'prop-types';
import DataTokenViewer from 'data-token-views/DataTokenViewer';
import { jsx as _jsx } from "react/jsx-runtime";
const TokenViewer = ({
  dataTokenContext,
  hideSiteSettingsCategory = false,
  includeSubscriptionTypeCategory,
  supportedCrmObjectFQNs,
  tagName,
  value
}) => {
  return /*#__PURE__*/_jsx(DataTokenViewer, {
    dataTokenContext: dataTokenContext,
    hideSiteSettingsCategory: hideSiteSettingsCategory,
    includeSubscriptionTypeCategory: includeSubscriptionTypeCategory,
    supportedCrmObjectFQNs: supportedCrmObjectFQNs,
    tagName: tagName,
    value: value
  });
};
TokenViewer.propTypes = {
  dataTokenContext: PropTypes.object,
  hideSiteSettingsCategory: PropTypes.bool,
  includeSubscriptionTypeCategory: PropTypes.bool,
  prefixes: PropTypes.objectOf(PropTypes.string),
  supportedCrmObjectFQNs: PropTypes.arrayOf(PropTypes.string),
  tagName: PropTypes.string,
  value: PropTypes.string.isRequired
};
export default TokenViewer;